import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
// import Slides from '@ifeng-fe/ui_pc_slides';
import { addEventListener } from '@ifeng-fe/ui_base';

/**
 * 定义 Slide 组件
 */
class Slide extends React.PureComponent {
    static propTypes = {
        func: PropTypes.object,
        currentData: PropTypes.object,
    };

    async componentDidMount() {
        const { changePage, handleKeyDown } = this.props.func;

        this.unhashchange = addEventListener(window, 'hashchange', changePage);
        this.unhandleKeyDown = addEventListener(window, 'keydown', handleKeyDown);
        changePage();
    }

    componentWillUnmount() {
        this.unhashchange();
        this.unhandleKeyDown();
    }

    /**
     * 渲染组件
     */
    render() {
        const { func, currentData } = this.props;
        const { handlePicPrev, handlePicNext, clickToShowPics } = func;

        return (
            <div className={styles.picDiv}>
                <div className={styles.pic}>
                    <div className={styles.photo_prev} style={{ width: '50%' }} onClick={handlePicPrev}>
                        <a
                            className={styles.btn_pphoto}
                            target="_self"
                            hidefocus="true"
                            title="上一张，支持 '← '翻页"
                        />
                    </div>
                    <div className={styles.photo_next} style={{ width: '50%' }} onClick={handlePicNext}>
                        <a
                            className={styles.btn_nphoto}
                            target="_self"
                            hidefocus="true"
                            title="下一张，支持 '→ '翻页"
                        />
                    </div>
                    <a>
                        {/* 图片尺寸width height */}
                        <img src={currentData.url} />
                    </a>
                </div>
                <p className={styles.text_con}>{currentData.description}</p>

                <div className={styles.functionPic} onClick={clickToShowPics}>
                    <img src="https://img.ifeng.com/hdslide/icon_11.gif" width="11" height="11" />
                    <a>全部图片</a>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Slide);
